import { vInCircle } from '../../assets/svg';

export const FEATURE_FLAG_ID = 'Ach Out Transfer';
export const VALID_FLAG_VALUE = 'show';

export const STEPS_MAP = {
  ZERO_STATE: 0,
  ENROLLMENT: 1,
  DETAILS: 2,
  CONFIRM_ACC_NUM: 3,
  TRANSFER_AMOUNT: 4,
  REVIEW_CONFIRM: 5,
  TRANSFER_DONE: 6,
  ENROLL_ERROR: 7,
  MFA: 8,
};

export const PREV_STEP_MAP = [0, 0, 1, 2, 3, 4];

export const FORM_INPUTS = [
  {
    TITLE: 'Payee or Business Name',
    TYPE: 'payeeName',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'payee',
  },
  {
    TITLE: 'Routing Number',
    TYPE: 'routingNumber',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'rout_num',
  },
  {
    TITLE: 'Account Number',
    TYPE: 'accountNumber',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'acc_num',
  },
];

export const FORM_STEPS_INPUTS = {
  CONFIRM_ACC_NUM: [
    {
      TITLE: 'ACCOUNT_NUMBER_INPUT_TITLE',
      TYPE: 'accountNumber',
      VALIDATION: '^{ACCOUNT_NUMBER}$',
      REPLACE: /\D/g,
      ERROR: 'ACCOUNT_NUMBER_INPUT_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 17,
    },
  ],
  DETAILS: [
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_1_TITLE',
      TYPE: 'businessName',
      VALIDATION: /^.{2,}$/,
      // REPLACE: /[^a-zA-z\s]/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_1_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 22,
      VALUE: '',
      DISABLED: false,
    },
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_2_TITLE',
      TYPE: 'accountNumber',
      VALIDATION: /^\d{6,17}$/,
      REPLACE: /\D/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_2_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 17,
      VALUE: '',
      DISABLED: false,
    },
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_3_TITLE',
      TYPE: 'routingNumber',
      VALIDATION: /^\d{9,9}$/,
      REPLACE: /\D/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_3_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 9,
      VALUE: '',
      DISABLED: false,
    },
  ],
};

export const CONTAINER_HEIGHTS = {
  SMALL: 'h-[548px]',
  MEDIUM: 'h-[618px]',
  LARGE: 'h-[594px]',
};

export const LIMITS_INITIAL_STATE = { balance: 0, monthlyLimit: 0, dailyLimit: 0 };

export const INITIAL_ACH_OUT_RESPONSE = { processTime: '', status: '', transactionId: '' };

export const FORM_INITIAL_STATE = {
  accountNumber: '',
  businessName: '',
  routingNumber: '',
  transferAmount: '',
  feeData: {
    achTransferType: '',
    arrivalDate: '',
    arrivalDateShort: '',
    fee: 0,
  },
};

export const LIMITS_TYPES = {
  BALANCE: 'balance',
  DAILY: 'dailyLimit',
  MONTHLY: 'monthlyLimit',
};

export const EDIT_MODE_TYPES = {
  AMOUNT: 'AMOUNT',
  DETAILS: 'DETAILS',
};

export interface IFormData {
  accountNumber: string;
  businessName: string;
  routingNumber: string;
  transferAmount: string;
  feeData: { achTransferType: string; arrivalDate: string; arrivalDateShort?: string; fee: number };
}

export interface IAchOutFees {
  expirationDate: Date;
  feeDescription: string;
  fees: [{ achTransferType: string; arrivalDate: string; arrivalDateShort: string; fee: number }];
  updatedAt?: Date;
}

export const TRANSFER_DONE_DATA = {
  CONTAINER: {
    CSS: 'w-[456px] h-fit relative flex flex-col w-[456px] h-fit rounded-[8px] bg-bw00 pt-[40px] pb-[24px] px-[40px]',
  },
  ICON: {
    SRC: vInCircle,
    CSS: 'w-[94px] h-[94px]',
  },
  HEADING: {
    TEXT: 'ACH_OUT_DONE.TITLE',
    CSS: 'font-metricMedium text-[25px] text-bw08 mt-[24px] h-[32px] mb-[8px]',
  },
  DISCLAIMER: {
    TEXT: 'ACH_OUT_DONE.DISCLAIMER',
    CSS: 'font-metric text-bw07 text-base h-[20px] mb-[22px]',
  },
  BUTTONS_CONTAINER: {
    CSS: 'flex justify-between mt-[16px]',
  },
  MAKE_ANOTHER_CTA: {
    TEXT: 'ACH_OUT_DONE.MAKE_ANOTHER_CTA',
    CSS: 'text-sm font-metricMedium text-action03 pl-[10px]',
  },
  DONE_CTA: {
    TEXT: 'ACH_OUT_DONE.DONE_CTA',
    CSS: 'w-[198px] h-[50px] bg-action03 hover:bg-action04 text-bw00 text-sm font-metricSemibold rounded-umd',
  },
  TRANSFER_DETAILS: {
    STYLES: {
      UPPER_ROW: 'h-[48px] flex justify-between py-[12px] px-[12px] border-b-[1px] border-bw03',
      ROW: 'h-[48px] flex justify-between py-[12px] px-[12px] border-b-[1px] border-bw03',
      LOWER_ROW: 'h-[48px] flex justify-center py-[12px] px-[12px]',
      PLACE_HOLDER: 'font-metric text-bw05 text-base',
      VALUE_WRAPPER: 'flex items-center',
    },
    AMOUNT: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.AMOUNT',
      CSS: 'text-[20px] text-action03 font-metricMedium',
    },
    RECIPIENT: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.TO',
      CSS: 'text-base text-bw08 font-metricMedium',
    },
    ACC_NUM: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.ACC_NUM',
      CSS: 'text-base text-bw07 font-metric',
    },
    ROUT_NUM: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.ROUT_NUM',
      CSS: 'text-base text-bw07 font-metric',
    },
    EST_ARR: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.EST_ARR',
      CSS: 'text-base text-bw08 font-metric',
    },
    PROC_DATE: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.PROC_DATE',
      CSS: 'font-metric text-bw06 text-sm',
    },
  },
} as const;

export const FLOW_INDEX_DATA = {
  PAGE_HEADER: 'ACH_OUT_PAGE_HEADER',
  CSS: {
    LAYOUT:
      'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
    BACK_BUTTON_STYLE: 'flex items-center justify-center w-[2rem]',
    NAV_BAR_STYLE: 'flex items-start mb-6 mt-[18px]',
    HEADER_STYLE: 'text-bw08 font-metricMedium text-xl',
    MAIN_CONTENT_WIDTH: 'w-[456px]',
    MAIN_CONTENT_MFA: 'w-full h-full',
  },
} as const;
export const STEP_SWITCH_DATA = {
  ZERO_STATE_CONTAINER:
    'flex flex-col items-center justify-center w-[456px] h-[548px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
  SPINNER_SIZE: '2rem',
} as const;
export const CONFIRM_DATA = {
  TEXTS: {
    TITLE: 'ACH_OUT_CONFIRM.TITLE',
    TEXT: 'ACH_OUT_CONFIRM.TEXT',
    FORM_SUBMIT: 'ACH_OUT_CONFIRM.FORM_SUBMIT',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] h-[594px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    TITLE: 'font-metricMedium text-[24px] text-bw08 mb-[16px]',
    TEXT: 'font-metric text-[16px] text-bw07 mb-[40px]',
    FORM: 'flex flex-col h-full',
    FORM_SUBMIT: 'w-[240px] mx-auto',
  },
} as const;
export const ENROLL_DATA = {
  TEXTS: {
    TITLE: 'ACH_OUT_ENROLL.TITLE',
    TEXT: 'ACH_OUT_ENROLL.TEXT',
    SUBMIT_CTA: 'ACH_OUT_ENROLL.SUBMIT_CTA',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] h-[548px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    ICON: 'w-[94px] mb-[20px]',
    TITLE: 'font-metricMedium text-[24px] text-bw08 mb-[16px]',
    TEXT: 'font-metric text-[16px] text-bw07',
    SUBMIT_CTA:
      'font-metricSemibold text-bw00 hover:bg-action04 bg-action03 py-[13px] text-base rounded-[4px] w-[240px] mt-auto',
  },
} as const;
export const DETAILS_DATA = {
  TEXTS: {
    TITLE_EDIT_ON: 'ACH_OUT_DETAILS.TITLE_EDIT_ON',
    TITLE_EDIT_OFF: 'ACH_OUT_DETAILS.TITLE_EDIT_OFF',
    SUBMIT_CTA_EDIT_ON: 'ACH_OUT_DETAILS.SUBMIT_CTA_EDIT_ON',
    SUBMIT_CTA_EDIT_OFF: 'ACH_OUT_DETAILS.SUBMIT_CTA_EDIT_OFF',
    CANCEL_CTA: 'ACH_OUT_DETAILS.CANCEL_CTA',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    EDIT_ON: 'h-[672px] animate-fadeIn',
    EDIT_OFF: 'h-[594px]',
    TITLE: 'font-metricMedium text-[24px] text-bw08 mb-[16px]',
    FORM: 'flex flex-col h-full',
    SUBMIT_CTA: 'w-[240px] mx-auto',
    SUBMIT_CTA_EDIT: 'mb-[16px]',
    CANCEL_CTA: 'font-metric text-[14px] text-bw06',
  },
} as const;

// TODO REEM
// const AMOUNT_DATA = {};
export const REVIEW_DATA = {
  STYLES: {
    CONTAINER: 'relative flex flex-col w-[456px] h-fit rounded-[8px] bg-bw00 py-[16px] px-[40px]',
    MAIN_HEAD: 'font-metricMedium text-[24px] text-bw08 mb-[16px]',
    REVIEW_ITEM_CONTAINER: 'flex justify-between py-[16px] px-[16px]',
    REVIEW_ITEM_CONTAINER_BORDER: 'border-b-[1px] border-bw03',
    REVIEW_ITEM_HEADER: 'font-metric text-bw05 text-base',
    TRANSFER_ITEMS_CONTAINER: 'flex flex-col py-[12px] px-[12px]',
    TRANSFER_ITEMS_HEAD: 'font-metricMedium text-base text-bw07 mb-[12px]',
    REVIEW_AMOUNT: 'text-[20px] text-action03 font-metricMedium mr-[8px]',
    REVIEW_PAYEE: 'text-base text-bw08 font-metricMedium mr-[8px]',
    REVIEW_ACCOUNT_NUMBER: 'text-base text-bw07 font-metric mr-[8px]',
    EDIT_ICON: 'w-[18px] hover:cursor-pointer',
    TRANSFER_ICON: 'w-[20px] mr-[8px]',
    INFO_ICON: 'w-[14px] hover:cursor-pointer',
    TOOL_TIP_CONTAINER:
      'absolute translate-x-[82%] translate-y-[-90%] top-0 right-0 flex flex-col justify-center mt-[-15px]',
    TOOL_TIP_CONTENT:
      'w-[209px] h-[69px] text-xxs w-full font-metric text-bw07 rounded-md px-[6px] py-2 bg-bw00 border border-bw05',
    TOOL_TIP_TRIANGLE: 'mt-[-10px] ml-[20px] z-0',
    TOOL_TIP_TRIANGLE_CLASS: 'triangle-F2F4F7',
    TOOL_TIP_HEAD: 'font-metric text-[14px] text-bw08',
    TOOL_TIP_DESC: 'font-metric text-[12px] text-bw07 z-100 leading-[16px]',
    TRANSFER_FEE: 'ml-auto font-metric text-bw07 text-[14px]',
  },
};
export const ERROR_DATA = {
  STYLES: {
    CONTAINER: 'flex flex-col w-[456px] h-[500px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    ICON: 'w-[76px] mb-[30px]',
    MAIN_HEAD: 'font-metricMedium text-bw08 text-[20px] mb-[12px]',
    DESC: 'font-metric text-[16px] text-bw07 max-w-[312px]',
    CTAS_WRAPPER: 'flex flex-col mt-auto',
    MAIN_CTA: 'max-w-[100%] mt-auto text-sm text-bw00 bg-action03 h-12 rounded font-metricBold mb-[12px]',
    SEC_CTA: 'font-metric text-[14px] text-bw06',
  },
};

export const ACH_OUT_ERRORS = {
  INSUFFICIENT_BALANCE_CODE_NAME: 'ACH_OUT_INSUFFICIENT_BALANCE',
  INSUFFICIENT_BALANCE_CODE: 4244,
} as const;
